var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dynamicComponent)?_c(_vm.dynamicComponent,_vm._g(_vm._b({tag:"component"},'component',_vm.$props,false),_vm.$listeners)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }